import loadable from '@loadable/component';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Animated, AppState, BackHandler, Linking, Platform, Text, TouchableOpacity, View } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { showSheet } from '../../../../../actions/SheetActions';
import FabBackButton from '../../../../../components/fab-back-button/FabBackButton.componet';
import PrimaryButton from '../../../../../components/primary-button/PrimaryButton.component';
import { selectrootsheettype } from '../../../../../selectors/SheetSelector';
import styles from './BuyPackageSheet.style';
import { colorPalette, textStyles } from '../../../../../theme';
import TextWithIconBox from '../../../buy-package/components/text-with-icon-box/TextWithIconBox.component';
import DiscountPercent from '../../../../trip/components/discount-percent/DiscountPercent.component';
import { staticNumberFormatter } from '../../../../../utils/NumberFormatter';
import WalletItem from '../../../../payment/components/WalletItem';
import { useMutation, useQuery } from 'react-query';
import { useApi } from '../../../../../providers/ApiProvider';
import { hideAlert, showAlert } from '../../../../../actions/AlertActions';
import {
  AnalyticsEvent,
  AnalyticsUserProperties,
} from '../../../../../services/analytics/FirebaseAnalytics';
import { getUser } from '../../../../../actions/user';
import { getApp } from '../../../../../actions/app';
import { isWeb } from '../../../../../constants';
import { useHistory } from '../../../../../imports/Router';
import Sentry from 'src/imports/sentry';
const SVG = loadable(() => import('../../../../../imports/svg'));

export default function BuyPackageSheet(props) {
  const { t } = useTranslation();
  const { api } = useApi();
  const dispatch = useDispatch();
  const translateY = useRef(new Animated.Value(421)).current;
  const [isUseWallet, setIsUseWallet] = useState(false);
  const [walletUsedAmount, setWalletUsedAmount] = useState(0);
  const [payableAmount, setPayableAmount] = useState(0);
  const [loading‌button, setloading‌button] = useState(false);
  const history = useHistory()
  const { sheetId, sheetProps } = useSelector(state =>
    selectrootsheettype(state),
  );
  var purchase_value = '';
  let lin = '';
  const { hasPayment } = useSelector(state => state?.app);

  const { data: profileResponse } = useQuery(['profile'], () => api.profile(), {
    onError: err => {
      console.log('profile_error', err);
    },
  });
  const wallet_credit = profileResponse?.Data?.wallet_credit;

  useEffect(() => {
    if (isUseWallet) {
      if (wallet_credit >= sheetProps?.price) {
        setPayableAmount(0);
        setWalletUsedAmount(sheetProps?.price);
      } else {
        setPayableAmount(Math.abs(sheetProps?.price - wallet_credit));
        setWalletUsedAmount(wallet_credit);
      }
    } else {
      setWalletUsedAmount(0);
      setPayableAmount(sheetProps?.price);
    }
  }, [isUseWallet, wallet_credit]);

  useEffect(() => {
    switch (sheetId) {
      case 'buyPackage':
        Animated.timing(translateY, {
          toValue: 0,
          duration: 400,
          useNativeDriver: true,
        }).start();
        break;
      default:
        closeHandler();
        break;
    }
  }, [sheetId]);

  const closeHandler = () => {
    Animated.timing(translateY, {
      toValue: 421,
      duration: 400,
      useNativeDriver: true,
    }).start();
    setTimeout(() => {
      dispatch(showSheet({ sheetId: '' }));
    }, 400);
  };

  //---------------------------------------------------handle payment deeplink
  const handleAppStateChange = useCallback(
    nextAppState => {
      if (nextAppState === 'active' && hasPayment) {
        lastPaymentMutation.mutate()
        dispatch(
          getApp({
            hasPayment: false,
          }),
        );
      }
    },
    [hasPayment],
  );

  const handleOpenURL = async ev => {
    const route = ev.url;
    if (route.includes('Status')) {
      dispatch(
        showAlert({
          id: 'Loading',
        }),
      );
      lastPaymentMutation.mutate()
    }
  };
  //---------------------------------------------------

  const openInNewTab = () => {
    lin = window.open('about:blank', '_blank');
    lin.opener = null;
  };

  const lastPaymentMutation = useMutation({
    mutationFn: async () => {
      return api.lastPaymentStatus();
    },
    onSuccess: response => {
      const success = response?.Data?.PaymentSuccess ?? false
      const message = response?.Data?.CheckoutDescription ?? ''
      const depositCredit = response?.Data?.DepositCredit ?? 0
      const walletCredit = response?.Data?.WalletCredit ?? 0
      setloading‌button(false);
      dispatch(hideAlert());
      dispatch(
        getUser({
          deposit_credit: depositCredit,
          wallet_credit: walletCredit
        }),
      );
      if (message !== '' && !success) {
        dispatch(
          showAlert({
            id: 'AlertBox',
            modalProps: {
              icon: success ? 'greenTick' : 'redExclamation',
              title : message,
            },
          }),
        );
      }
      if (success) {
        dispatch(showSheet({ sheetId: '', sheetProps: undefined }));
        history.push({
          pathname: '/payment-success',
          state: {
            title: 'your_balance_increased',
            description: message !== '' ? message : t('purchase_package_is_successfully'),
            buttonTitle: 'back_to_map',
            route: '/main/map',
          },
        });
        AnalyticsEvent({
          type: 'purchase',
          params: {
            purchase_amount: purchase_value,
            payment_method: 'cash',
            purchase_purpose: 'credit_tapup',
          },
        });
        AnalyticsEvent({
          type: 'paid_deposit',
        });
        AnalyticsUserProperties({
          user_deposit: 'paid',
        });
      } else {
        dispatch(showSheet({ sheetId: '', sheetProps: undefined }));
        history.push({
          pathname: '/payment-error',
          state: {
            buttonTitle: 'back_to_map',
            route: '/main/map',
          },
        });
      }
    },
    onError: (err) => {
      setloading‌button(false);
      dispatch(hideAlert());
      console.log('err', err.response)

    },
  });

  const packageBuyMutation = useMutation({
    mutationFn: async body => {
      return api.packagesBuy(body);
    },
    onSuccess: () => {
      setloading‌button(false);
      dispatch(showSheet({ sheetId: '' }))
      lastPaymentMutation.mutate();
      AnalyticsEvent({
        type: 'purchase',
        params: {
          purchase_amount: sheetProps?.price,
          payment_method: 'credit',
          purchase_purpose: 'purchase_package',
          purchase_package_id: sheetProps?.id,
        },
      });
      AnalyticsUserProperties({
        user_package: sheetProps?.id,
      });
    },
    onError: err => {
      setloading‌button(false);
      let error = err?.response?.data?.Result;
      dispatch(showSheet({ sheetId: '' }))
      if (error === 'Error_debtor') {
        dispatch(
          showAlert({
            id: 'AlertBox',
            modalProps: {
              icon: 'orangeExclamation',
              title: t('pay_previous_trip_first_then_buy_package'),
            },
          }),
        );
      } else if (error === 'Error_PackageEnd') {
        dispatch(
          showAlert({
            id: 'AlertBox',
            modalProps: {
              icon: 'redExclamation',
              title : t('error_making_connection') , 
              message: t('package_capacity_error'),
            },
          }),
        );
      }
    },
  });

  const paymentRequestPaymentMutation = useMutation({
    mutationFn: async body => {
      return api.paymentRequestPayment(body);
    },
    onSuccess: response => {
      setloading‌button(false);
      dispatch(
        getApp({
          hasPayment: true,
        }),
      );
      let link = response?.Data?.url;
      Platform.OS === 'web'
        ? (lin.location.href = link)
        : Linking.openURL(link);
      if ( isWeb ) {
        dispatch(
          showAlert({
            id: 'Loading',
          }),
        );
      }  
    },
    onError: err => {
      const error_type = err?.response?.data?.Result;
      const status = err?.response?.status;
      const errorMesage = err?.message === 'Network Error' ? 'Network Error' : error_type;
      Sentry.setTag("api_error", "payment_request");
      Sentry.captureMessage(`Error in buying package ${errorMesage} - ${status}`);
      setloading‌button(false);
      dispatch(
        getApp({
          hasPayment: false,
        }),
      );
      if (err?.response?.data?.Result == 'Error_debtor') {
        dispatch(
          showAlert({
            id: 'AlertBox',
            modalProps: {
              icon: 'orangeExclamation',
              title: t('pay_previous_trip_first_then_buy_package'),
            },
          }),
        );
      } else if (err?.response?.status === 404) {
        dispatch(
          showAlert({
            id: 'AlertBox',
            modalProps: {
              icon: 'redExclamation',
              title : t('connecting_payment_gateway_fail'),
              message : t('please_try_again_after_few_moment')
            },
          }),
        );
      }

    },
  });

  function onSubmit() {
    if (payableAmount === 0) {
      setloading‌button(true);
      packageBuyMutation.mutate({
        package_id: sheetProps.id,
      });
    } else {
      setloading‌button(true);
      if (isWeb) {
        openInNewTab();
      }
      paymentRequestPaymentMutation.mutate({
        Amount: payableAmount,
        Type: Platform.OS != 'web' ? 1 : 2,
        RidePackageIdForBuy: sheetProps?.id,
        IsWallet: true,
      });
      purchase_value = payableAmount;
    }
  }

  useEffect(() => {
    if (isWeb) {
      const subscrption = AppState.addEventListener(
        'change',
        handleAppStateChange,
      );
      return () => {
        subscrption.remove();
      };
    } else {
      const subscrption = Linking.addEventListener('url', handleOpenURL);

      return () => {
        subscrption.remove();
      };
    }
  }, [hasPayment]);

  return (
    <>
      <TouchableOpacity
        activeOpacity={1}
        onPress={closeHandler}
        style={styles.container}
      />
      <Animated.View
        style={[{ transform: [{ translateY: translateY }] }, styles.content]}>
        <View style={styles.indicator} />
        <FabBackButton
          container_style={styles.closeBtn}
          onPress={closeHandler}
          icon={'closeIcon'}
        />
        <SVG name={'noPackage'} height={124} width={124} />
        <Text style={styles.name}>{sheetProps?.name}</Text>
        <View style={styles.vehicleRow}>
          <TextWithIconBox
            title={
              sheetProps?.supported_vehicle === 'all'
                ? `${sheetProps?.ride_time * sheetProps?.bicycle_coefficient
                } ${t('minutes_of_ride_by_bicycle')}`
                : sheetProps?.supported_vehicle === 'Bicycle'
                  ? t('specific_bicycle')
                  : t('specific_motor')
            }
            icon={
              sheetProps?.supported_vehicle === 'all'
                ? 'simpleBike'
                : 'dangerCircle'
            }
            containerStyle={[
              sheetProps?.supported_vehicle === 'all' &&
              styles.specificBackground,
            ]}
          />
          <View style={styles.gap} />
          {sheetProps?.supported_vehicle === 'all' && (
            <View style={styles.orContainer}>
              <Text style={styles.orText}>{t('or')}</Text>
            </View>
          )}
          <TextWithIconBox
            title={`${sheetProps?.ride_time} ${sheetProps?.supported_vehicle === 'Bicycle'
                ? t('minutes_of_ride_by_bicycle')
                : t('minutes_of_ride_by_motor')
              }`}
            icon={
              sheetProps?.supported_vehicle === 'Bicycle'
                ? 'simpleBike'
                : 'simpleMotor'
            }
          />
        </View>
        <TextWithIconBox
          title={`${t('a_package')} ${sheetProps?.duration} ${t('days')}`}
          icon={'packageHourglass'}
          containerStyle={styles.expire}
        />
        <Factor
          title={'package_fee'}
          value={sheetProps?.price}
          textColor={colorPalette.grey9}
        />
        {sheetProps?.real_price - sheetProps?.price > 0 && (
          <Factor
            isDiscount
            title={'discount'}
            value={
              (
                (sheetProps?.real_price - sheetProps?.price) /
                sheetProps?.real_price
              ).toFixed(2) * 100 ?? 0
            }
          />
        )}
        <Factor title={'wallet_amount'} value={walletUsedAmount} />
        <Factor
          title={'amount_payable'}
          value={payableAmount}
          containerStyle={styles.payFactor}
        />
        {wallet_credit !== 0 && (
          <WalletItem
            isSelected={isUseWallet}
            balance={wallet_credit}
            isOn={isUseWallet}
            onToggle={setIsUseWallet}
          />
        )}
        <PrimaryButton
          title={t('click_here_to_buy')}
          containerStyle={styles.button}
          isLoading={loading‌button}
          isDisabled={loading‌button}
          onPress={onSubmit}
        />
      </Animated.View>
    </>
  );
}

function Factor(props) {
  const { isDiscount, title, value, textColor, containerStyle } = props;
  const { t } = useTranslation();
  return (
    <View style={[styles.factorContainer, containerStyle]}>
      {isDiscount ? (
        <DiscountPercent
          value={value}
          containerStyle={styles.discountPercent}
        />
      ) : (
        <Text
          style={[styles.factorText, { color: textColor ?? colorPalette.grey7 }]}>
          {staticNumberFormatter(value)} {t('toman')}
        </Text>
      )}
      <Text
        style={[styles.factorText, { color: textColor ?? colorPalette.grey7 }]}>
        {t(title)}
      </Text>
    </View>
  );
}
